// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/docs/v1/docs.proto (package mono.docs.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ApplyDocumentOperationsRequest, ApplyDocumentOperationsResponse, CreateDocumentRequest, CreateDocumentResponse, CreateFolderRequest, CreateFolderResponse, DeleteDocumentRequest, DeleteDocumentResponse, DeleteFolderRequest, DeleteFolderResponse, GetDocumentRequest, GetDocumentResponse, GetDocumentTextRequest, GetDocumentTextResponse, GetEditSessionRequest, GetEditSessionResponse, GetFolderRequest, GetFolderResponse, ListDocumentsRequest, ListDocumentsResponse, ListFoldersRequest, ListFoldersResponse, ListVersionsRequest, ListVersionsResponse, MoveDocumentRequest, MoveDocumentResponse, PingRequest, PingResponse, RenameDocumentRequest, RenameDocumentResponse, RenameFolderRequest, RenameFolderResponse, RestoreVersionRequest, RestoreVersionResponse } from "./docs_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * DocumentsService manages collaboratively-editable documents backed by
 * ONLYOFFICE Document Server. The service owns metadata, storage, versioning,
 * folders, and ONLYOFFICE callback handling.
 *
 * @generated from service mono.docs.v1.DocumentsService
 */ export const DocumentsService = {
    typeName: "mono.docs.v1.DocumentsService",
    methods: {
        /**
     * Ping is a health check RPC.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.Ping
     */ ping: {
            name: "Ping",
            I: PingRequest,
            O: PingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Document CRUD
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListDocuments
     */ listDocuments: {
            name: "ListDocuments",
            I: ListDocumentsRequest,
            O: ListDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocument
     */ getDocument: {
            name: "GetDocument",
            I: GetDocumentRequest,
            O: GetDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.CreateDocument
     */ createDocument: {
            name: "CreateDocument",
            I: CreateDocumentRequest,
            O: CreateDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RenameDocument
     */ renameDocument: {
            name: "RenameDocument",
            I: RenameDocumentRequest,
            O: RenameDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.MoveDocument
     */ moveDocument: {
            name: "MoveDocument",
            I: MoveDocumentRequest,
            O: MoveDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.DeleteDocument
     */ deleteDocument: {
            name: "DeleteDocument",
            I: DeleteDocumentRequest,
            O: DeleteDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Folder management
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListFolders
     */ listFolders: {
            name: "ListFolders",
            I: ListFoldersRequest,
            O: ListFoldersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.GetFolder
     */ getFolder: {
            name: "GetFolder",
            I: GetFolderRequest,
            O: GetFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.CreateFolder
     */ createFolder: {
            name: "CreateFolder",
            I: CreateFolderRequest,
            O: CreateFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RenameFolder
     */ renameFolder: {
            name: "RenameFolder",
            I: RenameFolderRequest,
            O: RenameFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.DeleteFolder
     */ deleteFolder: {
            name: "DeleteFolder",
            I: DeleteFolderRequest,
            O: DeleteFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * Edit session — returns the signed ONLYOFFICE editor config the frontend
     * passes to <DocumentEditor>.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetEditSession
     */ getEditSession: {
            name: "GetEditSession",
            I: GetEditSessionRequest,
            O: GetEditSessionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Versioning
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListVersions
     */ listVersions: {
            name: "ListVersions",
            I: ListVersionsRequest,
            O: ListVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RestoreVersion
     */ restoreVersion: {
            name: "RestoreVersion",
            I: RestoreVersionRequest,
            O: RestoreVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * ApplyDocumentOperations applies AI-proposed edit operations to a document
     * server-side, via ONLYOFFICE Document Builder, producing a new version. This
     * replaces the browser-side connector apply, which requires the paid
     * Developer Edition the community docserver does not ship.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ApplyDocumentOperations
     */ applyDocumentOperations: {
            name: "ApplyDocumentOperations",
            I: ApplyDocumentOperationsRequest,
            O: ApplyDocumentOperationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDocumentText returns the plain-text content of a document's current
     * version, extracted server-side from the stored bytes. Lets the assistant
     * read what a standalone document actually contains before editing it (so
     * edits target the real text) rather than treating it as blank.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentText
     */ getDocumentText: {
            name: "GetDocumentText",
            I: GetDocumentTextRequest,
            O: GetDocumentTextResponse,
            kind: MethodKind.Unary
        }
    }
};
